import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { AgeRange, Gender, IProfileState } from ".";

export interface ISetProfileResponse {
    gender: Gender;
    ageRange: AgeRange;
};

export const setProfile = createAsyncThunk<ISetProfileResponse, { gender: Gender, ageRange: AgeRange }>(
    'setProfile',
    async ({ gender, ageRange }) => await api.profiles.setProfile(gender, ageRange)
);

export const setProfileHandler = (builder: ActionReducerMapBuilder<IProfileState>) => {    
    builder
        .addCase(setProfile.pending, (state: IProfileState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(setProfile.fulfilled, (state: IProfileState, action: PayloadAction<ISetProfileResponse>) => {
            state.loading = false;
            state.gender = action.payload?.gender;
            state.ageRange = action.payload?.ageRange;
        })
        .addCase(setProfile.rejected, (state: IProfileState) => {
            state.loading = false;
            state.error = 'Unable to set profile';
        });
};

export default setProfileHandler;